export const resolveUrl = (relativeUrl: string): string => {
  // Do not resolve absolute URLs
  if (/http:\/\/|https:\/\//.test(relativeUrl)) {
    return relativeUrl;
  }

  return new URL(relativeUrl, import.meta.env.VUE_APP_BASE_URL).href;
};

// Localize
export const resolveListingUrl = (localizedPath: string, listingId: string): string =>
  resolveUrl(`/${localizedPath}/${listingId}`);
